const GET_TRANSACTIONS = "/backoffice/transaction";
const GET_FILTERED_TRANSACTIONS = "/backoffice/transaction/filter";
const DOWNLOAD_TRANSACTIONS = "/backoffice/transaction/download/filter";

export const TRANSACTIONS_ROUTES = {
  GET_TRANSACTIONS,
  GET_FILTERED_TRANSACTIONS,
  DOWNLOAD_TRANSACTIONS,
};
